import React from 'react'

const PhoneIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.66797 6.66658C2.66797 4.15243 2.66797 2.89535 3.44902 2.1143C4.23007 1.33325 5.48714 1.33325 8.0013 1.33325C10.5155 1.33325 11.7725 1.33325 12.5536 2.1143C13.3346 2.89535 13.3346 4.15243 13.3346 6.66658V9.33325C13.3346 11.8474 13.3346 13.1045 12.5536 13.8855C11.7725 14.6666 10.5155 14.6666 8.0013 14.6666C5.48714 14.6666 4.23007 14.6666 3.44902 13.8855C2.66797 13.1045 2.66797 11.8474 2.66797 9.33325V6.66658Z" stroke="#737373" />
            <path d="M10 12.6667H6" stroke="#737373" strokeLinecap="round" />
        </svg>
    )
}

export default PhoneIcon